if (window.acf) {
  window.acf.addAction("render_block_preview/type=service-grid", ($block) => {
    $block = $block[0].querySelector(".card-grid");

    $block.style.setProperty(`--card-container-width`, `${$block.offsetWidth}px`);
    window.addEventListener("resize", () => {
      $block.style.setProperty(`--card-container-width`, `${$block.offsetWidth}px`);
    });
  });
} else {
  document.querySelectorAll(".card-grid").forEach((grid) => {
    grid.style.setProperty(`--card-container-width`, `${grid.offsetWidth}px`);
    window.addEventListener("resize", () => {
      grid.style.setProperty(`--card-container-width`, `${grid.offsetWidth}px`);
    });
  });
}
